var map = {
	"./bfs/app/shared/search/search-results/search-results.component": [
		95616,
		"src_themes_bfs_app_shared_search_search-results_search-results_component_ts"
	],
	"./custom/app/shared/search/search-results/search-results.component": [
		27826,
		"src_themes_custom_app_shared_search_search-results_search-results_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 18527;
module.exports = webpackAsyncContext;